"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/health/v1/cms_service.proto (package spwn.health.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSHealthService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.health.v1.CMSHealthService
 */
exports.CMSHealthService = {
    typeName: "spwn.health.v1.CMSHealthService",
    methods: {
        /**
         * ヘルスチェック
         *
         * @generated from rpc spwn.health.v1.CMSHealthService.GetHealth
         */
        getHealth: {
            name: "GetHealth",
            I: cms_service_pb_1.CMSHealthServiceGetHealthRequest,
            O: cms_service_pb_1.CMSHealthServiceGetHealthResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map